module.exports = __webpack_public_path__ + "static/Aprendizagem-d72ca1115db613bafda81079131aa5e8.svg";